import classNames from 'classnames';
import { useCallback, useState } from 'react';

import { ReactSVG } from 'react-svg';
import { useTranslation } from 'utils/i18n';
// hooks
import { useApiRequest } from '../../../hooks/useApiRequest';

const icons = {
  email: '../../../images/icons/email.svg',
};

const Confirmation = ({
  email,
  existingCompany,
}: {
  email: string;
  existingCompany?: boolean;
}) => {
  const { t } = useTranslation('common');
  const [responseMessage, setResponseMessage] = useState<{
    error: boolean;
    content: string | null;
  }>({
    error: false,
    content: null,
  });

  const apiRequest = useApiRequest();

  const responseClasses = classNames({
    'registration-confirmation__response-message': true,
    'registration-confirmation__response-message--error': responseMessage.error,
  });

  const resendValidationEmail = useCallback(async () => {
    await apiRequest
      .get(`/v1/users/registrations/resend_validation_email?email=${email}`)
      .then(() => {
        setResponseMessage({
          error: false,
          content: t('registration.confirmation.validation_email_sent'),
        });
      })
      .catch(error => {
        setResponseMessage({
          error: true,
          content: error.response.data.message,
        });
      });
  }, [apiRequest, email, t]);

  return (
    <div className="registration-confirmation">
      <h3 data-cy="registrationHeader">
        {t('registration.confirmation.title')}
      </h3>
      <p className="registration-confirmation__instructions">
        {t('registration.confirmation.instructions')}
      </p>
      <ReactSVG
        className="registration-confirmation__email_icon"
        src={icons.email}
      />
      <p className="registration-confirmation__message">
        {!existingCompany && t('registration.confirmation.new_account_message')}
        {existingCompany &&
          t('registration.confirmation.existing_account_message')}
      </p>
      <p className="registration-confirmation__actions">
        <a className="button button--primary" href="/" data-cy="homeButton">
          {t('registration.confirmation.return_to_homepage')}
        </a>
        <br />
        {!existingCompany && (
          <>
            <button
              type="button"
              className="button button--text"
              onClick={resendValidationEmail}
            >
              {t('registration.confirmation.re_request_email')}
            </button>

            {responseMessage.content && (
              <p className={responseClasses}>{responseMessage.content}</p>
            )}
          </>
        )}
      </p>
    </div>
  );
};

export default Confirmation;
